import React from "react";
import CreateTodoList from "components/TodoList/CreateTodoList/CreateTodoList";
import TimelineTodoList from "components/TodoList/TimelineTodoLists/TimelineTodoLists";
import { useTeamContext } from "store/contexts/teamContext";
import InfiniteScroll from "react-infinite-scroll-component";
import { TimelineContext } from "store/contexts/timelineContext";
import Loader from "components/Loader";
import { useSelector, useDispatch } from "react-redux";
import * as timelineActions from "reteamStore/actions";
import Button from "components/CustomButton";
import { useTeamActionContext } from "store/contexts/teamActionContext";

export default () => {
  const { team } = useTeamContext();
  const { allTimelineTodoList } = useTeamActionContext();
  const dispatch = useDispatch();
  const { total, page, isLoading, timelineTodoList } = useSelector(
    (state) => state.todoListReducer
  );
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const createTodo = (todo) => {
    if (!todo) {
      return;
    }

    dispatch(timelineActions.createList(todo));
  };

  const updateTodo = (todo) => {
    dispatch(timelineActions.updateList(todo));
  };

  const getNextPageData = () => {
    allTimelineTodoList(page + 1);
    dispatch(timelineActions.listPageIncreament());
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!isLoading && (
        <h4>
          <Button onClick={getNextPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  return (
    <TimelineContext.Provider
      value={{
        createTodo,
        updateTodo,
      }}
    >
      <CreateTodoList team={team} />
      <InfiniteScroll
        style={{ overflow: "hidden" }}
        dataLength={total ?? 0}
        next={getNextPageData}
        hasMore={timelineTodoList.length !== total}
        loader={LoadingContainer}
        scrollableTarget="main-panel-right"
        endMessage={
          <div style={{ textAlign: "center" }}>
            {total > 0 && <div>Yay! You have seen it all</div>}
          </div>
        }
      >
        <TimelineTodoList todoLists={timelineTodoList} total={total} />
      </InfiniteScroll>
    </TimelineContext.Provider>
  );
};
